module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showGroup) ? _c('div', {
    staticClass: "channels-filters"
  }, [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "channels-scroll",
    class: {
      'long-group': _vm.isLong, 'short-group': !_vm.isLong
    }
  }, [_c('el-collapse', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.groupedChannelOptions), function(channelOptions, channelType) {
    return _c('el-collapse-item', {
      key: channelType,
      attrs: {
        "name": channelType
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "collapse-title"
    }, [_vm._v(_vm._s(channelType.toUpperCase()))])]), _vm._v(" "), _c('div', [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: (_vm.selectedOptions),
        callback: function($$v) {
          _vm.selectedOptions = $$v
        },
        expression: "selectedOptions"
      }
    }, _vm._l((channelOptions), function(option) {
      return _c('div', {
        key: option.id
      }, [_c('el-checkbox', {
        attrs: {
          "label": option.id
        }
      }, [_c('social-icon', {
        staticClass: "fa fa-fw",
        attrs: {
          "type": _vm.capitalize(option.type)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "option"
      }, [_vm._v(_vm._s(option.handle))])], 1)], 1)
    }), 0)], 1)], 2)
  }), 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a16552f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/ChannelsFilter.vue
// module id = 3293
// module chunks = 3